window.addEventListener('DOMContentLoaded', function(event) {
  var dhEvent = window.dhEvent;

  //保留手機版品項圖片位置
  function itemOffset () {
    setTimeout(() => {
      if($(window).outerWidth() < 640) {
        var itemImageHeight = $('#dhshopItemImages').outerHeight() + 45;
        $('#dhshopItem').css('padding-top', itemImageHeight);
      } else {
        $('#dhshopItem').css('padding-top', 0);
      }
    }, 0);
  }

  $('body').addClass('item-page');
  dhEvent.quantity();
  dhEvent.favoriteButton();
  dhEvent.modalVideo();
  dhEvent.copyDiscountCoupon();
  itemOffset()
  dhEvent.copyDiscountCoupon();

  // 品項資訊卡浮動
  UIkit.util.on('.dh-item-group-info-sticky', 'inactive', function() {
    $('.dh-item-group-info-sticky').addClass('isOpen')
  });
  $('#shrinkItemInfo').on('click', function() {
    $('.dh-item-group-info-sticky').toggleClass('isOpen')
    if($('.dh-item-group-info-sticky').hasClass('isOpen')) {
      $(this).find('i').addClass('icon-chevron-up').removeClass('icon-chevron-down')
    } else {
      $(this).find('i').addClass('icon-chevron-down').removeClass('icon-chevron-up')

    }
  })
  // ./品項資訊卡浮動

  $('#skipStepGoToShopCar').on('click', function() {
    dhEvent.swalConfirmDialog().fire({
      title: '確定要跳過加購嗎?',
      text: '加購物品有額外的打折，錯過了會非常可惜哦～',
      icon: 'warning',
      confirmButtonText: '確定',
      cancelButtonText: '否'
    }).then((result) => {
      if(result.value) {
        document.location.href = "/shopping";
      } else {
        UIkit.modal('#plusPurchaseModal').show();
      }
    })
  })


  $('input.itemQty').on('change', function() {
    var qty = $(this).val();
    $('input.itemQty').val(qty);
    $('.addShopCar').data('qty', qty);
  })
  $('.addShopCar').on('click', function() {
    var qty = Number($('.addShopCar').data('qty'));
    $('.dh-badge-lightsalmon').text(Number($('.dh-badge-lightsalmon').text()) + qty)
    dhEvent.swalToast().fire({
      icon: 'success',
      title: '加入購物車成功',
      timer: 2000,
    })
  })
  $('.dh-select-plus-purchase').find('.uk-checkbox').on('change', function() {
    let $this = $(this);
    if($this.prop('checked')) {
      $this.next('.uk-card').addClass('ischecked')
    } else {
      $this.next('.uk-card').removeClass('ischecked')
    }
  });

  $(window).resize(function() {
    itemOffset();
  })
});